import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },
  }),
);

const H2: React.FC = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="h2" className={classes.root}>
      {children}
    </Typography>
  );
};

export default H2;
